import { newsList } from "@/mocks/news";
import { Link } from "react-router-dom";

export default function NewsTicker() {
  const loop = [...newsList, ...newsList];
  return (
    <section className="w-full border-y border-background-200 bg-background-100" aria-label="影视资讯快讯">
      <div className="flex w-full items-stretch">
        <div className="flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50 md:px-6">
          <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>
          <span className="whitespace-nowrap">影视快讯</span>
        </div>
        <div className="group relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-8 py-3 group-hover:[animation-play-state:paused]">
            {loop.map((n, i) => (
              <Link
                key={`${n.id}-${i}`}
                to="/about"
                className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600 cursor-pointer"
              >
                <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">{n.tag}</span>
                {n.title}
                <span className="text-xs text-foreground-400">{n.date}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}